import { FEATURE } from '@abiglobalhealth/go-types'
import { useMemo } from 'react'

import { useConfig } from './useConfig'

export const useNavOnly = () => {
  const { config } = useConfig()
  const isNavOnly = useMemo(() => config?.features?.includes(FEATURE.HEALTH_NAVIGATOR_ONLY), [config])

  const returnToNavigator = () => {
    window.location.href = window.location.origin + window.location.pathname
  }

  return { isNavOnly, returnToNavigator }
}
